export const TITLE = 'Job Details';

export const DESCRIPTION = 'Information for the lender and your customer';
